import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Toggle from 'react-toggle';

import messages from '../taskMessages';
import TaskOverviewFilters, {
  defaultFilters as taskOverviewDefaultFilters,
} from '../taskOverview/TaskOverviewFilters';

// Reuse the full TaskOverview filter shape so every dynamic filter is supported here too.
// Keys not relevant on this screen (includeParameters, userIsNextAssignedUser) are still part of
// the shape so saved filters round-trip cleanly, they just aren't surfaced in the UI.
export const defaultFilters = taskOverviewDefaultFilters;

const TaskProgressPerEmployeeFilters = ({
  filters,
  templates,
  onFilterChange,
  useExecutionDuration,
  onUseExecutionDurationChange,
  countEmployees,
}) => {
  const renderDurationToggle = () => (
    <label className="react-toggle-wrapper margin10R">
      <Toggle
        checked={useExecutionDuration}
        onChange={e => onUseExecutionDurationChange(e.target.checked)}
      />
      <span className="label-text">
        <FormattedMessage {...messages.ShowByExecutionDuration} />
      </span>
    </label>
  );

  return (
    <>
      <TaskOverviewFilters
        filters={filters}
        templates={templates || []}
        onFilterChange={onFilterChange}
        showIncludeParameters={false}
        showDisplayModeToggles={false}
        showNextInLineToggle={false}
        renderTrailingToggles={renderDurationToggle}
        screen="TaskProgressPerEmployee"
        dynamicFiltersStorageKey="TaskProgressPerEmployeeDynamicFilters"
      />
      {countEmployees != null && (
        <div className="info-block container-fluid">
          <div className="row">
            <div className="col-md-12 batch-count">
              <p>
                {countEmployees === 0 ? (
                  <FormattedMessage {...messages.TaskProgressNoEmployees} />
                ) : (
                  <FormattedMessage
                    {...messages.TaskProgressEmployeeCount}
                    values={{ count: countEmployees }}
                  />
                )}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

TaskProgressPerEmployeeFilters.propTypes = {
  filters: PropTypes.shape({
    taskId: PropTypes.string,
    periodicityId: PropTypes.string,
    periodicityLineId: PropTypes.string,
    period: PropTypes.string,
    userId: PropTypes.string,
    username: PropTypes.string,
  }).isRequired,
  templates: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string.isRequired, label: PropTypes.string.isRequired }),
  ),
  onFilterChange: PropTypes.func.isRequired,
  useExecutionDuration: PropTypes.bool.isRequired,
  onUseExecutionDurationChange: PropTypes.func.isRequired,
  countEmployees: PropTypes.number,
};

TaskProgressPerEmployeeFilters.defaultProps = {
  templates: null,
  countEmployees: null,
};

export default TaskProgressPerEmployeeFilters;
